import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { restoreFavorites } from './actions'

export default compose(
  connect(null, { restoreFavorites }),
  lifecycle({
    componentDidMount() {
      this.props.restoreFavorites()
    }
  })
)

